import dayjs from 'dayjs';
import { message } from 'ant-design-vue';
import { getCustomerDataApi } from '../api/admin/customer';
import { findPath } from './helper/treeHelper';

interface TreeItem {
  pid: number;
  id: number;
  name: string;
  children?: [];
}

export interface SourceItem {
  id: number;
  name: string;
  children?: SourceItem[];
}

// [id] 根据id获取树的路径id列表
export function getAllParentId(tree, ids) {
  const pathList = ids.map((id) => findPath(tree, (n) => n.id === id) || []);
  const idList = pathList.map((i) => i.map((ii) => ii.id) || []);
  return idList;
}

// 树结构转扁平结构
export function treeToFlat(source: SourceItem[]) {
  const flat: SourceItem[] = [];
  source.forEach((el) => {
    flat.push(el);
    el.children && flat.push(...treeToFlat(el.children));
  });
  return flat;
}

// 扁平结构转树结构
export function flatToTree(oldData: TreeItem[] = [], id: number, newData: TreeItem[] = []) {
  oldData.forEach((item) => {
    item.pid === id && newData.push(item);
  });
  return newData.map((i) => {
    const tree = {
      children: flatToTree(oldData, i.id, i.children) || [],
      label: i.name,
      value: i.id,
    };
    if (tree.children.length === 0) delete tree.children;
    return tree;
  });
}

// 下拉框搜索
export function filterOption(input: string, option: any) {
  console.log('[ filterOption ] >', option);
  return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
}

// 级联搜索
export function filterPath(inputValue: string, path: any) {
  return path.some((option) => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
}

// 天眼查校验客户名称
export async function handleCustomerNameValidate(
  name,
  model,
  typesId,
  getCityList,
  getDistrictList,
) {
  if (!name) return;
  try {
    const {
      customerAttr,
      customerTypes,
      staffNumRange,
      creditCode,
      regLocation,
      zoneId,
      cityId,
      districtId,
      product,
      industry,
    } = await getCustomerDataApi({
      data: { name, type: 'search', web: 1, typesId },
    });
    if (typesId !== customerAttr) {
      return message.error('客户名称与当前客户属性不匹配');
    }
    model.customerSubTypesId = customerTypes;
    model.staffNumRange = staffNumRange;
    model.creditCode = creditCode;
    model.detailAddress = regLocation;
    model.product = product;
    model.industry = industry;
    model.zoneId = zoneId;
    getCityList(zoneId);
    model.cityId = cityId;
    getDistrictList(cityId);
    model.districtId = districtId;
  } catch (error) {
    console.log('[ handleCustomerNameValidate error ] >', error);
  }
}

// 判断有无查询条件。没有查询条件时，提示
export function noParamsRemind(params) {
  const obj = Object.assign({}, params);
  delete obj.pageNo;
  delete obj.pageSize;
  const isEmpty = isEmptyObject(obj);
  if (isEmpty) {
    message.error('请选择查询条件');
  }
  return isEmpty;
}

export function setRangeTimeParams(params, { startTimeName, endTimeName }) {
  const isEmptyParams = isEmptyObject(params);
  if (isEmptyParams) {
    message.warning('无查询条件，默认日期为最近三个月');
    params[startTimeName] = dayjs()
      .subtract(3, 'month')
      .startOf('day')
      .format('YYYY-MM-DD HH:mm:ss');
    params[endTimeName] = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss');
  }
  return { transParams: params, isEmptyParams };
}

// 判断对象中的属性是否全部值为空
export function isEmptyObject(object = {}) {
  let flag = true;
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      const element = object[key];
      if (element) return (flag = false);
    }
  }
  return flag;
}

export function getLast3Month() {
  const now: any = new Date();
  const year: any = now.getFullYear();
  let month: any = now.getMonth() + 1; //0-11表示1-12月
  let day: any = now.getDate();
  const dateObj: any = {};
  if (parseInt(month) < 10) {
    month = '0' + month;
  }
  if (parseInt(day) < 10) {
    day = '0' + day;
  }

  dateObj.now = year + '-' + month + '-' + day;

  if (parseInt(month) == 1) {
    //如果是1月份，则取上一年的10月份
    dateObj.last = parseInt(year) - 1 + '-10-' + day;
    return dateObj;
  }
  if (parseInt(month) == 2) {
    //如果是2月份，则取上一年的11月份
    dateObj.last = parseInt(year) - 1 + '-11-' + day;
    return dateObj;
  }
  if (parseInt(month) == 3) {
    //如果是3月份，则取上一年的12月份
    dateObj.last = parseInt(year) - 1 + '-12-' + day;
    return dateObj;
  }

  const preSize = new Date(year, parseInt(month) - 3, 0).getDate(); //开始时间所在月的总天数

  if (preSize < parseInt(day)) {
    // 开始时间所在月的总天数<本月总天数，比如当前是5月30日，在2月中没有30，则取下个月的第一天(3月1日)为开始时间
    const resultMonth =
      parseInt(month) - 2 < 10 ? '0' + (parseInt(month) - 2) : parseInt(month) - 2;
    dateObj.last = year + '-' + resultMonth + '-01';
    return dateObj;
  }

  if (parseInt(month) <= 10) {
    const resultMonth = parseInt(month) - 3 < 10 ? `0${parseInt(month) - 3}` : parseInt(month) - 3;
    dateObj.last = year + '-' + resultMonth + '-' + day;
    return dateObj;
  } else {
    const resultMonth = parseInt(month) - 3 < 10 ? `0${parseInt(month) - 3}` : parseInt(month) - 3;
    dateObj.last = year + '-' + resultMonth + '-' + day;
    return dateObj;
  }
}

export function toCamel(str) {
  return str.replace(/([^_])(?:_+([^_]))/g, function (_$0, $1, $2) {
    return $1 + $2.toUpperCase();
  });
}

export function dataTimestampToFormat(data, format = 'YYYY-MM-DD HH:mm:ss') {
  data.forEach((item) => {
    for (const key in item) {
      if (Object.prototype.hasOwnProperty.call(item, key)) {
        let value = item[key];
        if (key.toLowerCase().includes('time')) {
          value = value ? dayjs.unix(value).format(format) : '';
          item[key] = value;
        }
      }
    }
  });
  return data;
}

/**
 * @description 金额数字格式化
 * @param num 金额
 * @param symbol 货币符号
 * @param useThousandSeparator 是否进行千分位划分
 * @returns 金额数字字符串
 */
export function formatCurrency(
  num: number | string,
  symbol = '¥',
  useThousandSeparator = true,
): string {
  num = typeof num === 'number' ? num : parseFloat(num) || 0;
  const formattedNum = num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  const currency = useThousandSeparator ? formattedNum : num.toFixed(2);

  return `${symbol}${currency}`;
}

/**
 * @description 百分比格式化
 * @param 百分比
 * @param symbol 百分比符号
 * @param useThousandSeparator 是否进行千分位划分
 * @returns 金额数字字符串
 */
export function formatPercent(
  num: number | string,
  symbol = '%',
  useThousandSeparator = true,
): string {
  num = typeof num === 'number' ? num : parseFloat(num) || 0;
  const formattedNum = num.toFixed(1).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  const currency = useThousandSeparator ? formattedNum : num.toFixed(1);

  return `${currency}${symbol}`;
}

/**
 * @description 金额取整
 * @param 金额
 * @param 1四舍五入 2向上取整 3向下取整 4去除小数点
 * @returns 金额数字字符串
 */
export function formatInt(num: number | string, useMeans = 1) {
  num = typeof num === 'number' ? num : parseFloat(num) || 0;
  const data = {
    1: Math.round(num),
    2: Math.ceil(num),
    3: Math.floor(num),
    4: Math.trunc(num),
  }[useMeans];
  return data;
}
